module.exports = __webpack_public_path__ + "static/media/publish-schedule-stories-desktop-en.3875fe7b.webp";